let copySource = {
    document: {
        title:'Buy/Gift Points'
    },
    headerNav:{
        logo:{
            alt:'Marriott Bonvoy',
            link:'https://www.marriott.com/default.mi'
        },
        home: {
            copy: 'Home',
            link: ''
        },
        buy: {
            copy:'Buy Points',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=en-US&iscid=points_buy_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=en-US&iscid=points_buy_cta_em_pr'
        },
        gift: {
            copy:'Gift Points',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=en-US&iscid=points_gift_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=en-US&iscid=points_gift_cta_em_pr'
        },
        multiply: {
            copy:'Multiply Points',
            stLink: 'https://sso-uat.lxc.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=en-US&iscid=points_multiply_plp_web_ev',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=en-US&iscid=points_multiply_plp_web_ev'
        },
        mr: {
            copy:'Marriott.com',
            link:'https://www.marriott.com/default.mi'
        }
    },
    hero: {
        lang: 'landing-en',
        headline: {
            lineOne: 'Points for the Whim.',
            lineTwo: 'Buy Now, Go Whenever.',
        },
        subHeadline : "When inspiration hits, have the points to make it\n happen. Whether it's a rewarding detour or an\n impromptu experience, there are countless places\n to go and things to do. Buy or gift points now.",
        alt:"Book a bucket-list trip. Spend more nights out on the town. It's the Year of More - and it's all possible with Marriott Bonvoy® points.",
    },
    promo: {
        hero: {
            promoLang: 'promo-en',
            headline: "Plan With More Points.",
            subheadline: "Then Go With The Flow.",
            body: "Get a bonus when you buy points by March 31. Need a beach vaca right away? Love it so much you want to stay longer? When inspiration hits, have the points to make it happen.",
        }
    },
    ctas:{
        buy:{
            imgAlt:'Interior hotel bedroom window overlooking cityscape.',
            header:'Buy Points',
            copy:"From adding an extra night to your stay to getting VIP access to a sold-out show, buy points now so you're ready for anything.",
            linkCopy:'Buy Points',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=en-US&iscid=points_buy_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=en-US&iscid=points_buy_cta_em_pr'
        },
        gift:{
            imgAlt:'Hotel balcony with a pool overlooking the ocean.',
            header:'Gift Points',
            copy:'Gift points to friends and family so they can wander whenever —\n and wherever — they want.',
            linkCopy:'Gift Points',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=en-US&iscid=points_gift_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=en-US&iscid=points_gift_cta_em_pr'
        },
        multiply:{
            imgAlt:'Hotel balcony with a pool overlooking the ocean.',
            header:'Multiply Points',
            copy:'Earned points on a recent stay? Now you can buy up to 4X more at a discount so you can live larger on your next trip.',
            linkCopy:'BUY POINTS & SAVE',
            stLink: 'https://sso-uat.lxc.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=en-US&iscid=points_multiply_plp_web_ev',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=en-US&iscid=points_multiply_plp_web_ev'
        },
        membership:{
            imgAlt:'',
            imgSrc: './images/mr_rebrand_register_Placeholder.png',
            header: 'Become a Member',
            link: 'https://www.marriott.com/loyalty/createAccount/createAccountPage1.mi?enrollmentSourceCode=MSPV',
            copy: 'Get access to Member Rates, points toward free nights, and more. New members may purchase points thirty (30) days after enrollment in the Marriott Bonvoy program.'
        }
    },
    footer:{
        copyrightOne:'This website is operated by Points.com Inc. on behalf of Marriott International, Inc. for the purchase of Marriott Bonvoy Points in accordance with the ',
        copyrightLinkTC: 'https://points-ebgt.s3.amazonaws.com/marriott/terms-conditions/bonvoy-terms-and-conditions-EN.html',
        copyrightTwo:'Points.com Inc. Terms and Conditions',
        copyrightThree:'. The awarding and use of Marriott Bonvoy Points in connection with a purchase transaction are subject to the ',
        copyrightLinkTwo: 'https://www.marriott.com/loyalty/terms/default.mi',
        copyrightFour:'Marriott Bonvoy Program Rules',
        copyrightFive:' and ',
        copyrightLinkTwo: 'https://www.marriott.com/about/privacy.mi',
        copyrightSix:'Privacy Policy',
        copyrightSeven:'.',
        
        options: {
            de: "Deutsch",
            es: "Español",
            en:'English',
            fr: 'Français',
            it: 'Italiano',
            jp:'日本語',
            pt:'Português',
            ch:'国际'
        },
        footerbar:{
            logo: "./images/bonvoy_logo.png",
            grp1: "LUXURY",
            grp2: "PREMIUM",
            grp3: "SELECT",
            grp4: "MIDSCALE",
            grp5: "LONGER STAYS"
        },
        langIconSrc: './images/Icon-Globe.svg',
        langIconAlt: 'English',
        tracking:{
            doNotSell:{
                copy:'Do Not Sell My Personal Information',
                href:'https://www.marriott.com/about/ccpa/do-not-sell.mi'
            },
            prefs: {
                copy:'Tracking Preferences',
                href:'https://consent-pref.trustarc.com/?layout=gdpr&type=marriottgdpr&site=marriottgdpr.com&action=notice&country=ca&locale=en&behavior=implied&irm=undefined&from=https://consent.trustarc.com/'
            }
        },
        terms:{
            copy:'Terms of Use',
            href:'https://www.marriott.com/about/terms-of-use.mi'
        },
        programTerms:{
            copy:'Program Terms & Conditions',
            href:'https://www.marriott.com/loyalty/terms/default.mi'
        },
        privacy:{
            copy:'Privacy Center',
            href:'https://www.marriott.com/privacy.mi'
        },
        accessibility:{
            copy:'Digital Accessibility',
            href:'https://www.marriott.com/digital-accessibility.mi'
        },
        siteMap:{
            copy:'Site Map',
            href:'https://www.marriott.com/sitemap.mi'
        },
        help:{
            copy:'Help',
            href:'https://help.marriott.com/s/'
        },
    }
    
}

export default copySource
